import React from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { money, surfaceSx } from "./ownerCenterUi";

function Metric({ label, value, emphasis = false }) {
  return (
    <Box sx={{ minWidth: 0, px: { xs: .2, sm: .5 }, flex: { xs: "1 1 90px", sm: "0 1 auto" } }}>
      <Typography sx={{ color: "text.secondary", fontWeight: 850, fontSize: 10.5, lineHeight: 1.1 }}>{label}</Typography>
      <Typography
        sx={{
          mt: .2,
          fontWeight: 1000,
          fontSize: { xs: 15.5, sm: 17.5 },
          letterSpacing: "-.03em",
          color: emphasis ? "warning.main" : "text.primary",
          whiteSpace: { xs: "normal", sm: "nowrap" },
          overflow: { xs: "visible", sm: "hidden" },
          textOverflow: { xs: "clip", sm: "ellipsis" },
          overflowWrap: { xs: "anywhere", sm: "normal" },
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function OwnerMoneyRealityStrip({ center, assistant, currency = "ARS", onCurrencyChange, onOpenFinance }) {
  const available = Number(center?.finance?.totalsByCurrency?.[currency] || 0);
  const outstanding = Number(center?.commercial?.outstandingByCurrency?.[currency] || 0);
  const recurringFloor = Number(assistant?.economy?.monthlyRecurringFloor || 0);
  const currencies = [...new Set([...(assistant?.currencies || []), currency])].filter(Boolean).slice(0, 3);

  return (
    <Box data-owner-jarvis-section="today-money" sx={{ ...surfaceSx, px: { xs: 1.15, sm: 1.4 }, py: .85 }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          minWidth: 0,
          display: { xs: "grid", sm: "flex" },
          gridTemplateColumns: { xs: "auto minmax(0, 1fr)", sm: "none" },
          columnGap: { xs: .75, sm: 1 },
          rowGap: { xs: .75, sm: 0 },
        }}
      >
        <Typography sx={{ fontWeight: 1000, fontSize: 12.5, flexShrink: 0 }}>Dinero</Typography>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", sm: "block" } }} />
        <Stack
          direction="row"
          alignItems={{ xs: "start", sm: "center" }}
          sx={{
            minWidth: 0,
            flex: { xs: "0 0 auto", sm: 1 },
            width: { xs: "100%", sm: "auto" },
            display: { xs: "grid", sm: "flex" },
            gridTemplateColumns: { xs: "repeat(3, minmax(0, 1fr))", sm: "none" },
            gridColumn: { xs: "1 / -1", sm: "auto" },
            gridRow: { xs: 2, sm: "auto" },
            gap: { xs: .75, sm: 1.35 },
            overflowX: { xs: "visible", sm: "auto" },
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Metric label="Disponible" value={money(available, currency)} />
          <Metric label="Por cobrar" value={money(outstanding, currency)} emphasis={outstanding > 0} />
          <Metric label="Base mensual" value={money(recurringFloor, currency)} />
        </Stack>
        <Stack
          direction="row"
          spacing={.15}
          alignItems="center"
          sx={{
            flexShrink: 0,
            gridColumn: { xs: 2, sm: "auto" },
            gridRow: { xs: 1, sm: "auto" },
            justifySelf: { xs: "end", sm: "auto" },
            minWidth: 0,
          }}
        >
          {currencies.map((item) => (
            <Button key={item} size="small" variant={item === currency ? "contained" : "text"} onClick={() => onCurrencyChange?.(item)} sx={{ minWidth: 34, px: .5, borderRadius: 1.6, fontWeight: 1000, fontSize: 10.5 }}>{item}</Button>
          ))}
          <Button size="small" endIcon={<ArrowForwardRoundedIcon />} onClick={onOpenFinance} sx={{ display: { xs: "none", sm: "inline-flex" }, minWidth: 0, px: .5, textTransform: "none", fontWeight: 950 }}>Finanzas</Button>
        </Stack>
      </Stack>
    </Box>
  );
}
